<div class="container-idle" [class.show]="idleState!='Started'">
	<div class="modal shake-horizontal" tabindex="-1" [class.show]="idleState!='Started'">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Cierre de sesión automático</h5>
				</div>
				<div class="modal-body">
					Por seguridad tu sesión es invalidada si pasas más de <b>20 minutos inactivo</b>
					<br> Tienes <span class="countdown">{{time}}</span> segundos
					para <b>mover el mouse o tocar una tecla</b>  y reactivar tu sesión o deberás de ingresar de
					nuevo.
				</div>
				<div class="modal-footer">
					<div id="clock_wrapper">
						<canvas id="clock" width="300" height="300"></canvas>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>